import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { css } from '@emotion/core';
import UnderscoreDivider from './UnderscoreDivider';
import { ssColorWhite, ssColorBlack, ssColorCyan } from '../constants/style-constants';
import {
  Paragraph,
  DisplayHeader,
  Header2,
  Header3,
  Header4,
} from './Typography';

const renderHeaderComponent = ({ level, ...props }) => {
  switch (level) {
    case 1:
      return <DisplayHeader {...props} />;
    case 2:
      return <Header2 {...props} />;
    case 3:
      return <Header3 {...props} />;
    case 4:
    default:
      return <Header4 {...props} />;
  }
};

renderHeaderComponent.propTypes = {
  level: PropTypes.number.isRequired,
};

const ContentBlockCSS = css`
  background: ${ssColorBlack};
  padding: 3rem;

  &, h1, h2, h3, h4 {
    color: ${ssColorWhite};
  }

  ${DisplayHeader} {
    color: ${ssColorCyan};
  }
`;

const ShareImageCSS = css`
  width: 100%;
  max-width: 750px;
  border: 2px ${ssColorCyan} solid;
  margin: 2rem 0;
`;

const MarkdownBlock = ({
  markdown,
  imageUrl,
}) => (
  <div css={ContentBlockCSS}>
    <ReactMarkdown
      source={markdown}
      renderers={{
        // --- alt text is provided by markdown ---
        // eslint-disable-next-line jsx-a11y/alt-text
        image: props => <img {...props} src={imageUrl} css={ShareImageCSS} />,
        thematicBreak: props => <UnderscoreDivider {...props} />,
        paragraph: props => <Paragraph {...props} />,
        heading: props => renderHeaderComponent(props),
      }}
    />
  </div>
);

MarkdownBlock.defaultProps = {
  imageUrl: null,
};

MarkdownBlock.propTypes = {
  markdown: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
};

export default MarkdownBlock;
